import React from "react";
import { showLocalDate, tolocalDate } from "../../../utilities/functions";

const StyledDateOut = ({ row }) => {
  return <>{row.punchOut ? showLocalDate(row.punchOut) : ""}</>;
};

export default StyledDateOut;
